var declareExternalFeatures = function (features) {
    return features;
};
export { declareExternalFeatures };
//# sourceMappingURL=declareExternalFeatures.js.map